import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

import { first } from 'rxjs';
import { BreadcrumbService } from 'src/app/services/breadcrumb.service';
import { ImmeublesService } from 'src/app/services/immeubles.service';
import { formatAddressTitle } from 'src/app/utils/address-format.utils';

@Component({
  selector: 'app-building-details',
  templateUrl: './building-details.component.html',
  styleUrls: ['./building-details.component.scss']
})
export class BuildingDetailsComponent implements OnInit {
  numero_immeuble: any;
  buildingDetails: any;

  showingMap = false;
  google_embed_url: SafeResourceUrl;
  google_full_map_url: string;

  constructor(
    private router: Router,
    private readonly route: ActivatedRoute,
    private immeublesService: ImmeublesService,
    private sanitizer: DomSanitizer,
    private breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.numero_immeuble = params['numero_immeuble'];
      if (this.numero_immeuble) {
        this.immeublesService
          .getBuildingDetails(this.numero_immeuble)
          .pipe(first())
          .subscribe((buildingDetails) => {
            this.buildingDetails = buildingDetails;
            // hard coded value
            this.buildingDetails.nom_proprietaire = 'Nom Exemple';

            // FIl d'ariane : Extraction de l'adresse courte (sans code postal)
            const adresseComplete = this.buildingDetails.adresse_immeuble;
            const adresseCourte = this.extraireAdresseCourte(adresseComplete);
            // Mise à jour du fil d'Ariane avec l'adresse courte
            this.breadcrumbService.setBreadcrumb(
              `/liste/${this.numero_immeuble}`,
              {
                numero_immeuble: this.numero_immeuble,
                adresse_immeuble_courte: adresseCourte
              }
            );

            // google maps urls
            this.google_embed_url =
              this.sanitizer.bypassSecurityTrustResourceUrl(
                encodeURI(
                  'https://maps.google.com/maps?&q=' +
                    this.buildingDetails.adresse_immeuble +
                    '&output=embed&language=fr'
                )
              );
            this.google_full_map_url = encodeURI(
              'https://maps.google.com/maps?&q=' +
                this.buildingDetails.adresse_immeuble +
                '&language=fr'
            );
          });
      }
    });
  }

  formatCertifications() {
    if (this.buildingDetails.certifications?.length > 0)
      return this.buildingDetails.certifications
        .map((certification) => certification.description)
        .join('; ');
    return 'Aucune';
  }

  formatTitle() {
    return formatAddressTitle(this.buildingDetails.adresse_immeuble);
  }

  toggleShowMap() {
    this.showingMap = !this.showingMap;
  }

  navigateToPoint() {
    const center = `${this.buildingDetails.longitude},${this.buildingDetails.latitude}`;

    this.router
      .navigate(['/carte'], {
        queryParams: { center: center, zoom: 17 }
      })
      .then(() => {
        window.location.reload();
      });
  }

  openGoogleMaps() {
    window.open(this.google_full_map_url, '_blank');
  }

  private extraireAdresseCourte(adresse: string): string {
    return adresse.replace(/,\s*[A-Z]\d[A-Z] \d[A-Z]\d$/, '').trim(); //chercher un code postal canadien valide en fin de chaîne et le supprimer proprement.
  }

  resolveTypeValue(type_propriete_ou_location) {
    if (type_propriete_ou_location.toLowerCase() === 'l') {
      return 'Location';
    } else if (type_propriete_ou_location.toLowerCase() === 'p') {
      return 'Propriété';
    } else {
      return type_propriete_ou_location;
    }
  }

  formatDirectorName(name: string): string {
    // Remove a word in parentheses at the end of the string, e.g. "John Doe (Directeur)" => "John Doe"
    return name.replace(/\s*\([^)]*\)\s*$/, '').trim();
  }

  formatAdminAddress(address: string): string {
    if (!address) return '';
    let formatted = address
      .replace(/ Boulevard /g, ', boulevard ')
      .replace(/ Avenue /g, ', avenue ')
      .replace(/ Quai /g, ', quai ')
      .replace(/ Rue /g, ', rue ');
    return formatted;
  }

  /**
   * Format a phone number from (418) 727-3750 to 418 727-3750
   * @param phone The phone number string
   * @returns The formatted phone number
   */
  formatPhoneNumber(phone: string): string {
    if (!phone) return '';
    // Match (418) 727-3750 or similar
    const match = phone.match(
      /^\(?([0-9]{3})\)?[\s.-]*([0-9]{3})[\s.-]*([0-9]{4})$/
    );
    if (match) {
      return `${match[1]} ${match[2]}-${match[3]}`;
    }
    return phone;
  }
}
